import React from "react";
import { Col, Row } from "react-bootstrap";
import { pageAnimation, titleAnim } from "../../animation";
import { useScroll } from "./useScroll";
import { motion } from "framer-motion";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";

const TransformText = () => {
  return "</ Changing the world one commit at a Time >";
};

const Home = ({ countData }) => {
  // const Home = () => {
  const [element, controls] = useScroll();
  return (
    <div id="home" className="fix  ">
      <div className="bg-image">
        <motion.div
          variants={pageAnimation}
          ref={element}
          animate={controls}
          className="container home-page-intro "
        >
          <Row className="home-row">
            <Col md={8} xs={12}>
              <motion.div className="intro-section">
                <motion.h5 variants={titleAnim} className="mb-5">
                  <h6 style={{ color: "white" }}>
                    {/* {" Page Count "} */}
                    {/* <RemoveRedEyeIcon /> {countData} */}
                  </h6>
                  <div>&emsp;</div>
                  <TransformText />
                </motion.h5>
                <motion.h1 variants={titleAnim} className="mb-4">
                  Hi, I'm{" "}
                  <span className="chonburi-font green-text">Tejas </span>
                  Sheth
                </motion.h1>
                {/* <motion.h3 variants={titleAnim} className="mb-4">
                  Former{" "}
                  <span className="chonburi-font green-text">
                    Tech Intern At
                  </span>{" "}
                  Mosaic Wellness Pvt. Ltd.
                </motion.h3> */}
                <motion.h5 variants={titleAnim} className="mb-4">
                  M.Sc in Computer Science,{" "}
                  <span className="chonburi-font green-text">
                    University of Southern California
                  </span>{" "}
                </motion.h5>
                <motion.h5 variants={titleAnim} className="mb-4">
                  B.Engg in Computer Engineering,{" "}
                  <span className="chonburi-font green-text">
                    University of Mumbai
                  </span>{" "}
                </motion.h5>
              </motion.div>
            </Col>
          </Row>
        </motion.div>
      </div>
    </div>
  );
};

export default Home;
